module.exports = __webpack_public_path__ + "img/crypto-xrp.bc1e48db.svg";